import HBSelect from "@/components/HBInput/select";
import HBModel from "@/components/HBModal";
import HBTagInput from "@/components/HBTagInput";
import uploadAccept from "@/constants/uploadAccept";
import useAppStore from "@/context/store";
import { getBoardSuggestTags, getTags } from "@/services";
import imageUrl from "@/utils/imageUrl";
import { isEmpty } from "@/utils/isEmpty";
import useOuterClick from "@/utils/useOuterClick";
import useRequest from "@/utils/useReq";
import { Button, Checkbox, Input } from "antd";
import classNames from "classnames";
import lodash from "lodash";
import { useState } from "react";
import { When } from "react-if";
import BoardSelect from "../../../BoardSelect";
import FilePicker from "../../../FilePicker";
import HBIcon from "../../../HBIcon";
import Image from "../../../Image";
import ImageAvatar, { STATUS } from "../ImageAvatar";
import ImageAvatarPlaceholder from "../ImageAvatar/placeholder";
import styles from "../index.module.less";
import ToolSelect from "./toolSelect";

// const canItemShow = (r) => !!r.extra?.is_creation;

export default function NormalUploader(props) {
  const {
    resources,
    selectedResource,
    currentResource,
    boardId,
    maxUploadAmount,
    canUpload,
    syncTagsChecked,
    globalTags,
    categories,
    categoryId,
    myBoardSelectRef,

    onCancelClick,
    onOkClick,
    onResourceSelect,
    onDescriptionChange,
    onTagsChange,
    onResourceRemove,
    onFilePicked,
    onReUploadFileClick,
    onlyCreation,
    onBoardChange,
    onSyncTags,
    onCategoryChange,
    onAiInfoChange,
    verifyVisible,
    setVerifyVisible,
    needCheckAi,
    setCheckPrompt,
  } = props;
  const [, setShowTagInput] = useState(false);
  const user = useAppStore((s) => s.user);
  const urlname = user?.urlname;
  const { data: tagsResult } = useRequest(
    async () => {
      if (!boardId) {
        return [];
      }
      let suggestTags = [];
      const oftenResult = await getTags({ urlname, sort: "often" });
      if (oftenResult?.recent?.length > 0) {
        suggestTags = oftenResult?.recent?.map((item) => item.tag_name) || [];
      } else {
        const suggestResult = await getBoardSuggestTags({ board_id: boardId });
        suggestTags = suggestResult?.tags || [];
      }
      return {
        suggestTags,
        tags: oftenResult?.tags,
      };
    },
    {
      refreshDeps: [boardId, urlname],
    }
  );
  // const selectSwitch = useMemo(() => {
  //   if (
  //     suggestTags?.length ||
  //     selectedResource?.tags?.length ||
  //     globalTags?.length
  //   ) {
  //     return undefined;
  //   }
  //   return false;
  // }, [suggestTags, globalTags, selectedResource]);
  const havePrompt = !isEmpty(
    selectedResource?.ossFile?.aigc?.prompt ||
      selectedResource?.ossFile?.aigc?.aigc_category
  );

  // 控制prompt输入框展示收起
  const [textAreaItemRef, promptExpand, setPromptExpand] = useOuterClick(false);
  const [promptTextFocused, setPromptTextFocused] = useState(false);

  return (
    <div
      className={styles.hasResources}
      data-content-source="添加采集"
      data-dialog-title="上传-信息填写弹窗"
      data-gd-expose="dialog_expose"
    >
      <div className={styles.left}>
        {!!selectedResource && (
          <>
            <div className={classNames(styles.cover)}>
              <Image
                className="transparent-img-bg"
                src={
                  imageUrl(selectedResource?.ossFile) || selectedResource.url
                }
                width={264}
                height={198}
                alt={"选中的图片"}
              />

              {currentResource && currentResource.status !== STATUS.DONE && (
                <div className={styles.notDoneMask}>
                  {currentResource.status === STATUS.UPLOADING && (
                    <div className={styles.progressContainer}>
                      <div
                        className={styles.progress}
                        style={{ width: `${currentResource.progress}%` }}
                      />
                    </div>
                  )}
                  {currentResource.status === STATUS.FAILURE && (
                    <div className={styles.errorTip}>
                      <span className={styles.tipSign}>
                        <HBIcon
                          className={classNames([styles.icon, styles.large])}
                          type={"ic_alert"}
                        />
                        {currentResource.failMsg && (
                          <div className={styles.failMsg}>
                            {currentResource.failMsg}
                          </div>
                        )}
                      </span>
                    </div>
                  )}
                </div>
              )}
            </div>

            <div className={styles.formItem}>
              <Input.TextArea
                wrap="off"
                placeholder="为作品添加描述"
                value={selectedResource?.description}
                onChange={onDescriptionChange}
                // disabled={currentResource?.status !== STATUS.DONE}
                onPressEnter={(e) => e.preventDefault()}
                className={styles.textArea}
                autoFocus
              />
            </div>
            <div className={styles.formItem} style={{ overflow: "hidden" }}>
              <HBTagInput
                className={styles.tagInput}
                placeholder="添加标签"
                // open={selectSwitch}
                tags={globalTags || selectedResource.tags}
                onChange={onTagsChange}
                suggestTags={tagsResult?.suggestTags}
                suggestVisible
                placement={"topRight"}
                allTags={tagsResult?.tags}
              >
                <When
                  condition={
                    selectedResource?.tags?.length || globalTags?.length
                  }
                >
                  <div className={styles.checkbox}>
                    <Checkbox checked={syncTagsChecked} onChange={onSyncTags}>
                      标签应用到全部采集
                    </Checkbox>
                  </div>
                </When>
              </HBTagInput>
            </div>
            <div
              className={classNames(styles.promptTextItem, {
                [styles.promptExpand]: havePrompt || promptExpand,
                [styles.focus]: promptTextFocused,
              })}
              ref={textAreaItemRef}
            >
              <ToolSelect
                value={selectedResource.ossFile?.aigc?.aigc_category}
                // 禁用情况只有当有初始prompt且有初始分类
                disabled={
                  selectedResource.hasOriginalPromot &&
                  selectedResource.hasOriginalCategory
                }
                onChange={(data) => {
                  onAiInfoChange(data, "aigc_category");
                }}
                show={havePrompt || promptExpand}
              ></ToolSelect>

              {/* <div className={styles.label}>AI绘图“咒语”</div> */}
              <Input.TextArea
                className={classNames(styles.promptTextArea, {
                  [styles.verificationFailed]: needCheckAi && !havePrompt,
                })}
                maxLength={2000}
                disabled={
                  selectedResource.hasOriginalPromot ||
                  currentResource?.status !== STATUS.DONE
                }
                placeholder="添加提示词Prompt"
                value={selectedResource?.ossFile?.aigc?.prompt}
                onChange={(e) => {
                  onAiInfoChange(e.target.value, "prompt");
                }}
                onFocus={() => {
                  setPromptExpand(true);
                  setPromptTextFocused(true);
                }}
                onBlur={() => {
                  setPromptTextFocused(false);
                }}
              />
            </div>

            {/* <div
              className={classNames([
                styles.tool,
                !havePrompt ? styles.hide : null,
              ])}
            >
              <span>创作工具</span>
              <ToolSelect
                value={selectedResource.ossFile?.aigc?.aigc_category}
                // 禁用情况只有当有初始prompt且有初始分类
                disabled={
                  selectedResource.hasOriginalPromot &&
                  selectedResource.hasOriginalCategory
                }
                onChange={(data) => {
                  onAiInfoChange(data, "aigc_category");
                }}
              ></ToolSelect>
            </div> */}
            <When
              condition={
                selectedResource.ossFile?.aigc?.extra?.width &&
                selectedResource.ossFile?.aigc?.extra?.height
              }
            >
              <div className={styles.measurement}>
                <span>图片尺寸</span>
                <span>
                  {selectedResource.ossFile?.aigc?.extra?.width || 0} x
                  {selectedResource.ossFile?.aigc?.extra?.height || 0}px
                </span>
              </div>
            </When>
          </>
        )}
      </div>
      <div className={styles.right}>
        <div className={styles.title}>上传采集</div>
        <div className={styles.content}>
          <div className={styles.selectBoard}>
            <BoardSelect
              ref={myBoardSelectRef}
              allowClear
              placeholder="画板"
              useLabel={true}
              selectFirst={!boardId}
              onlyCreation={onlyCreation}
              onChange={onBoardChange}
              useCreation={true}
              value={boardId || null}
            />
          </div>
          <div
            className={styles.selectCategory}
            data-gd-click="button_click"
            data-button-name="选择画板分类"
            data-content-source="上传采集弹窗"
          >
            <HBSelect
              {...(categoryId ? { value: categoryId } : null)}
              optLabel="name"
              placement="bottomRight"
              placeholder="分类"
              disabled={boardId <= 0}
              dropdownClassName={styles.select}
              options={categories}
              onChange={onCategoryChange}
            />
          </div>
        </div>
        <div className={styles.uploadList}>
          <div
            className={styles.uploadList}
            style={{
              margin: 0,
              position: "absolute",
              top: 0,
              left: 0,
              overflow: "hidden",
            }}
          >
            {lodash.range(0, maxUploadAmount).map((idx) => (
              <ImageAvatarPlaceholder
                key={idx}
                className={styles.imageAvatar}
              />
            ))}
          </div>

          {resources.map((r, idx) => (
            <ImageAvatar
              key={`${idx}_${r.id}`}
              status={r.status}
              progress={r.progress}
              needCheckPromot={needCheckAi}
              coverUrl={imageUrl(r?.ossFile) || r.url}
              onClose={onResourceRemove(r)}
              onReUpload={onReUploadFileClick(r)}
              selected={selectedResource?.uid === r.uid}
              onSelect={() => {
                setShowTagInput(false);
                onResourceSelect(r)();
              }}
              className={styles.imageAvatar}
              resources={r}
            />
          ))}
        </div>
        <div className={styles.filePicker}>
          <FilePicker
            accept={uploadAccept}
            multiple
            onPick={onFilePicked}
            disabled={resources.length >= maxUploadAmount}
            ChildrenWrapper={({ isDragging }) => (
              <div
                className={classNames(styles.fileDropArea, {
                  [styles.isDragging]: isDragging,
                })}
              >
                {!isDragging ? (
                  <>
                    {maxUploadAmount > resources.length && (
                      <div className={styles.filePickerTip1}>
                        <HBIcon type={"add"} className={styles.icon} />
                        &nbsp; 拖拽图片到这里，或<span>点此添加</span>
                      </div>
                    )}
                    <div className={styles.filePickerTip2}>
                      已选
                      <span style={{ fontWeight: "bolder" }}>
                        {resources.length}
                      </span>
                      张，还可选
                      <span style={{ fontWeight: "bolder" }}>
                        {maxUploadAmount - resources.length}
                      </span>
                      张
                    </div>
                  </>
                ) : (
                  <>
                    <div className={styles.filePickerTip1}>
                      <HBIcon type={"upload"} className={styles.icon} />
                      &nbsp; 松开上传
                    </div>
                    <div className={styles.filePickerTip2}>
                      已选
                      <span style={{ fontWeight: "bolder" }}>
                        {resources.length}
                      </span>
                      张，还可选
                      <span style={{ fontWeight: "bolder" }}>
                        {maxUploadAmount - resources.length}
                      </span>
                      张
                    </div>
                  </>
                )}
              </div>
            )}
          />
        </div>
        <div className={styles.footActions}>
          <Button onClick={onCancelClick}>取消</Button>
          <Button
            type={"primary"}
            onClick={onOkClick}
            data-gd-click="button_click"
            data-button-name="上传"
            disabled={
              !boardId ||
              !!resources.find((r) => r.status !== STATUS.DONE) ||
              !canUpload
            }
          >
            上传
          </Button>
        </div>
      </div>
      <HBModel
        visible={verifyVisible}
        title={"AI作品信息未完善"}
        onCancel={() => {
          setVerifyVisible(false);
        }}
        footer={
          <div className={styles.footer}>
            <div className={styles.footerLeft}>
              <Checkbox
                className={styles.checkBox}
                onChange={() =>
                  setCheckPrompt((pre) => {
                    return !pre;
                  })
                }
              >
                不再提醒
              </Checkbox>
            </div>
            <div className={styles.footerRight}>
              <Button
                onClick={() => {
                  setVerifyVisible(false);
                  onOkClick(false);
                }}
              >
                上传为普通采集
              </Button>
              <Button
                type={"primary"}
                onClick={() => {
                  setVerifyVisible(false);
                }}
              >
                返回填写
              </Button>
            </div>
          </div>
        }
      >
        <div className={styles.modalDesc}>
          AI作品的提示词（Prompt）必填，如有缺失不会被发布至AI圈，但不影响您上传为普通采集，可在画板管理和查看。
        </div>
      </HBModel>
    </div>
  );
}
